import { SHOP_CUSTOMER_STATUSES, SHOP_SEARCH_MAX } from "@seagames/contracts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { MerchCustomersView } from "../../components/merch/customers-view";
import { keysetSearch } from "../../lib/list-page/list-search";

/** Merchandising › Customers: keyset; `q` is an exact email, `status` a chip. */
export const Route = createFileRoute("/_app/merchandising/customers")({
	validateSearch: keysetSearch({
		q: z.string().trim().min(1).max(SHOP_SEARCH_MAX),
		status: z.enum(SHOP_CUSTOMER_STATUSES),
	}),
	component: CustomersPage,
});

function CustomersPage() {
	return <MerchCustomersView search={Route.useSearch()} navigate={Route.useNavigate()} />;
}
